import { Group, Overlay, Paper } from "@mantine/core";

const NoItemsModal = ({
  rows,
  totalRows,
  loading,
  text,
  button,
  apiRef,
  ...props
}) => {
  if (
    rows.length === 0 &&
    !totalRows &&
    !loading &&
    apiRef?.current?.state?.filter?.filterModel?.items?.length <= 0
  )
    return (
      <>
        <Overlay
          color="var(--mantine-color-primary-2)"
          blur={1}
          pos={"absolute"}
          top={0}
          left={0}
          w={"100%"}
          h={"100%"}
          zIndex={25}
        />

        <Paper
          pos={"absolute"}
          style={{ zIndex: 33, transform: "translateX(-50%)" }}
          top={"30%"}
          left={"50%"}
          p={"xl"}
          radius={"xl"}
          {...props}
        >
          {text}

          {button && <Group justify="center">{button}</Group>}
        </Paper>
      </>
    );

  return "";
};

export default NoItemsModal;
